import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isIOS } from './utils/platformUtils';
// Import iOS styles (will only apply when ios-app class is present)
import './styles/ios.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Add iOS class for iOS-specific styling
if (isIOS()) {
  document.body.classList.add('ios-app');
  document.documentElement.classList.add('ios-app');
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
